import type {
	GetStaticProps,
	GetStaticPropsContext,
	GetStaticPropsResult,
	NextPage,
} from 'next';
import {serverSideTranslations} from 'next-i18next/serverSideTranslations';
import GroupsPage from '@components/GroupsPage';

const Groups: NextPage<{locale: string}> = ({locale}) => {
	return <GroupsPage locale={locale} />;
};

export const getStaticProps: GetStaticProps = async ({
	locale,
	locales,
}): Promise<GetStaticPropsResult<GetStaticPropsContext>> => {
	return {
		props: {
			locale,
			locales,
			...(await serverSideTranslations(locale || '', ['common'])),
		},
	};
};

export default Groups;
